import React from 'react';
import GenericDialog from '../components/GenericDialog';
import { AggregatedSubmission } from '../redux/types';
import { AuswertungSetting } from '../redux/types/auswertungSettingTypes';
import SurveyEvaluationResult from '../components/evaluation/SurveyEvaluationResult';

type Props = {
  admin?: boolean;
  trialId: number;
  trialName: string;
  enrollmentId: number;
  aggregatedSubmission?: AggregatedSubmission;
  groundTruthGroupId?: number;
  auswertungSetting?: AuswertungSetting;
  onClose?: () => void;
}

const DigitalEvaluationDialog: React.FC<Props> = ({
  admin,
  trialId,
  trialName,
  enrollmentId,
  aggregatedSubmission,
  groundTruthGroupId,
  auswertungSetting,
  onClose,
}: Props) => (
  <GenericDialog
    isOpen
    maxWidth="xl"
    onRequestClose={onClose}
  >
    <SurveyEvaluationResult
      admin={admin}
      trialId={trialId}
      trialName={trialName}
      enrollmentId={enrollmentId}
      aggregatedSubmission={aggregatedSubmission}
      groundTruthGroupId={groundTruthGroupId}
      auswertungSetting={auswertungSetting}
      onClose={onClose}
    />
  </GenericDialog>
);

export default DigitalEvaluationDialog;
